import * as l from "@radix-ui/react-collapsible";
const o = l.Root, e = l.CollapsibleTrigger, s = l.CollapsibleContent;
export {
  o as Collapsible,
  s as CollapsibleContent,
  e as CollapsibleTrigger
};
//# sourceMappingURL=Collapsible.js.map
